<template>
  <v-card id="resources" class="mt-4 rounded-lg" style="border: 1px solid #d0d0d0; border-radius: 0" elevation="0">
    <v-expansion-panels v-model="resourcesExpanded">
      <v-expansion-panel elevation="0">
        <v-expansion-panel-title class="pa-4">
          <div class="text-h6 font-weight-bold">Resources</div>

          <template v-slot:actions="{ expanded }">
            <v-icon size="28px" color="#747474">
              {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </template>
        </v-expansion-panel-title>

        <v-expansion-panel-text class="pa-0">
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(item, i) in filteredContents"
              :key="i"
              elevation="0"
              class="mb-4 mt-0"
              style="
                border-left: 8px solid #ffc627;
                border-right: 1px solid #d0d0d0;
                border-top: 1px solid #d0d0d0;
                border-bottom: 1px solid #d0d0d0;
                border-radius: 8px;
                overflow: hidden;
              "
              @update:modelValue="handleAccordionToggle(item.title, $event)"
            >
              <v-expansion-panel-title style="background: white; color: black">
                <div class="text-subtitle-3 font-weight-bold" style="font-size: 16px">
                  {{ item.title }}
                </div>

                <template v-slot:actions="{ expanded }">
                  <v-icon size="x-large" color="#747474">
                    {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </template>
              </v-expansion-panel-title>

              <v-expansion-panel-text class="pa-0">
                <v-card color="#fafafa" elevation="0">
                  <v-card-text class="text-body-1 font-weight-regular">
                    <span v-html="item.text" />
                  </v-card-text>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';

import { DataLayerMixin } from '../mixins/dataLayerMixin';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  name: 'ResourcesComponent',
  mixins: [DataLayerMixin, Helper],

  data() {
    return {
      resourcesExpanded: 0 // 0 = first panel expanded by default
    };
  },

  mounted() {
    // Load collapsed state from localStorage
    const savedState = localStorage.getItem('resources_collapsed');
    if (savedState !== null) {
      // If collapsed, set to undefined (no panel expanded)
      // If expanded, set to 0 (first panel expanded)
      this.resourcesExpanded = savedState === 'true' ? undefined : 0;
    }

    // let links = document.querySelectorAll('.resources a');
    // links.forEach((e, i) => {
    //   e.addEventListener('click', (event) => {
    //     this.asuoDataLayerClick('Resources', i);
    //   });
    // });
  },

  watch: {
    resourcesExpanded(newValue) {
      // Save state to localStorage
      // undefined or null means collapsed, 0 means expanded
      const isCollapsed = newValue === undefined || newValue === null;
      localStorage.setItem('resources_collapsed', isCollapsed.toString());
    }
  },

  props: {
    contents: Array,
    partnerName: String
  },

  computed: {
    filteredContents() {
      if (!this.contents) return [];

      return this.contents.filter((item) => {
        // If item is not partner-only, always show it
        if (!item.partnersOnly) {
          return true;
        }

        // If item is partner-only, only show if current partner is in the allowed list
        return (item.partnersOnly || []).indexOf(this.partnerName) > -1;
      });
    }
  },

  methods: {
    handleAccordionToggle(title, isOpen) {
      // Determine the action based on the accordion state
      const action = isOpen ? 'open' : 'close';
      // Call asuoDataLayerClick with the appropriate parameters
      isOpen &&
        this.asuoDataLayerClick('Resources', '0', {
          text: title,
          action
        });
    }
  }
});
</script>

<style lang="stylus">

#resources {
  .v-card-text > p {
    font-size: 16px !important;
  }

  // Remove default Vuetify pseudo-element borders
  .v-expansion-panel::before {
    box-shadow: none !important;
  }

  .v-expansion-panel::after {
    border-top: none !important;
  }

  // Force all panels to have rounded corners, not just first/last
  .v-expansion-panel {
    border-radius: 8px !important;
  }

  .v-expansion-panel-title {
    border-radius: 8px !important;
  }

  .v-expansion-panel-text {
    border-radius: 0 0 8px 8px !important;
  }

  // Remove bottom margin from last child expansion panel (inner panels with yellow border)
  .v-expansion-panel-text .v-expansion-panels .v-expansion-panel:last-child {
    margin-bottom: 0 !important;
  }
}
</style>
